<div class="locations-hero-header" directive="draw-base-height">
    <div class="locations-hero-header__inner">
        <div class="locations-hero-header__hd">
            <shared-header [brandAccent]="true" type="5" [center]="centerHeaders" marginTop="xs" marginBottom="none"
                class="locations-hero-header__subh" (click)="onBackClick($event)">
                <shared-icon-btn icon="back-arrow" [inverted]="true" size="sm" class="locations-hero-header__back"
                    title="select different store">
                </shared-icon-btn>ORDERING FROM
            </shared-header>
            <shared-header class="locations-hero-header__h" [center]="centerHeaders" [inverted]="true" type="1"
                marginTop="xs" marginBottom="xs">
                {{(location$ | async)?.LocationFriendlyName}}
            </shared-header>
        </div>

        <div class="locations-hero-header__bd">

            <shared-emphasis-text (click)="handleLocationAddressClick($event)" [multiLines]="true"
                class="locations-hero-header__address">
                {{(location$ | async)?.StreetAddress}}
            </shared-emphasis-text>

            <shared-open-status class="locations-hero-header__status" [inverted]="true"
                [openStatus]="openStatus$ | async">
            </shared-open-status>

        </div>

        <div class="locations-hero-header__actions">

            <ng-container [ngSwitch]="(collectionTypesLinks$ | async)?.length > 1">
                <shared-collection-type-toggle class="locations-hero-header__btn -for-collect-type" *ngSwitchCase="true"
                    [locationNo]="locationNo" feel="secondary" [size]="btnSize" [inverted]="true"
                    type="button-dropdown"></shared-collection-type-toggle>

                <shared-btn *ngSwitchDefault class="locations-hero-header__btn -for-more-info"
                    (onClick)="handleMoreInformationClick($event)" [size]="btnSize" [inverted]="true" feel="secondary">
                    more information
                </shared-btn>
            </ng-container>

            <ng-container>
                <shared-btn *ngIf="(isDineInActive$ | async) === true" [disabled]="true"
                    class="locations-hero-header__btn -for-placeholder" [size]="btnSize" [inverted]="false"
                    feel="primary">
                    Now
                </shared-btn>

                <shared-pickup-for-current-location class="locations-hero-header__btn -for-schedule"
                    *ngIf="(isDineInActive$ | async) === false" [locationNo]="locationNo" [size]="btnSize"
                    projection="global" iconRight="down">
                </shared-pickup-for-current-location>
            </ng-container>

        </div>

    </div>
</div>
